var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMisFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 103,
    viewBox: "0 0 38 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665_30853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.94082C5.43343 6.94082 7 5.38651 7 3.47041C7 1.55333 5.43343 0 3.5 0C1.56657 0 0 1.55431 0 3.47041C0 5.38651 1.56657 6.94082 3.5 6.94082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 20.8256C5.43343 20.8256 7 19.2723 7 17.3552C7 15.4381 5.43343 13.8848 3.5 13.8848C1.56657 13.8848 0 15.4391 0 17.3552C0 19.2713 1.56657 20.8256 3.5 20.8256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 34.7084C5.43343 34.7084 7 33.1541 7 31.238C7 29.3209 5.43343 27.7676 3.5 27.7676C1.56657 27.7676 0 29.3219 0 31.238C0 33.1541 1.56657 34.7084 3.5 34.7084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 48.5854C5.43343 48.5854 7 47.031 7 45.1149C7 43.1979 5.43343 41.6445 3.5 41.6445C1.56657 41.6445 0 43.1988 0 45.1149C0 47.032 1.56657 48.5854 3.5 48.5854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 62.4623C5.43343 62.4623 7 60.909 7 58.9919C7 57.0748 5.43343 55.5215 3.5 55.5215C1.56657 55.5215 0 57.0758 0 58.9919C0 60.908 1.56657 62.4623 3.5 62.4623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 75.3568C5.43343 75.3568 7 73.8035 7 71.8864C7 69.9693 5.43343 68.416 3.5 68.416C1.56657 68.416 0 69.9693 0 71.8864C0 73.8035 1.56657 75.3568 3.5 75.3568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 89.2416C5.43343 89.2416 7 87.6883 7 85.7712C7 83.8541 5.43343 82.3008 3.5 82.3008C1.56657 82.3008 0 83.8541 0 85.7712C0 87.6883 1.56657 89.2416 3.5 89.2416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 103.126C5.43343 103.126 7 101.572 7 99.656C7 97.7389 5.43343 96.1855 3.5 96.1855C1.56657 96.1855 0 97.7399 0 99.656C0 101.573 1.56657 103.126 3.5 103.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.94082C20.4324 6.94082 22 5.38651 22 3.47041C22 1.55333 20.4324 0 18.5 0C16.5666 0 15 1.55431 15 3.47041C15 5.38651 16.5666 6.94082 18.5 6.94082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.8256C20.4324 20.8256 22 19.2723 22 17.3552C22 15.4381 20.4324 13.8848 18.5 13.8848C16.5666 13.8848 15 15.4391 15 17.3552C15 19.2713 16.5666 20.8256 18.5 20.8256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 34.7084C20.4324 34.7084 22 33.1541 22 31.238C22 29.3209 20.4324 27.7676 18.5 27.7676C16.5666 27.7676 15 29.3219 15 31.238C15 33.1541 16.5666 34.7084 18.5 34.7084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 48.5854C20.4324 48.5854 22 47.031 22 45.1149C22 43.1979 20.4324 41.6445 18.5 41.6445C16.5666 41.6445 15 43.1988 15 45.1149C15 47.032 16.5666 48.5854 18.5 48.5854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 62.4623C20.4324 62.4623 22 60.909 22 58.9919C22 57.0748 20.4324 55.5215 18.5 55.5215C16.5666 55.5215 15 57.0758 15 58.9919C15 60.908 16.5666 62.4623 18.5 62.4623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 75.3568C20.4324 75.3568 22 73.8035 22 71.8864C22 69.9693 20.4324 68.416 18.5 68.416C16.5666 68.416 15 69.9693 15 71.8864C15 73.8035 16.5666 75.3568 18.5 75.3568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 89.2416C20.4324 89.2416 22 87.6883 22 85.7712C22 83.8541 20.4324 82.3008 18.5 82.3008C16.5666 82.3008 15 83.8541 15 85.7712C15 87.6883 16.5666 89.2416 18.5 89.2416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 103.126C20.4324 103.126 22 101.572 22 99.656C22 97.7389 20.4324 96.1855 18.5 96.1855C16.5666 96.1855 15 97.7399 15 99.656C15 101.573 16.5666 103.126 18.5 103.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 6.94082C36.4324 6.94082 38 5.38651 38 3.47041C38 1.55333 36.4324 0 34.5 0C32.5666 0 31 1.55431 31 3.47041C31 5.38651 32.5666 6.94082 34.5 6.94082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 20.8256C36.4324 20.8256 38 19.2723 38 17.3552C38 15.4381 36.4324 13.8848 34.5 13.8848C32.5666 13.8848 31 15.4391 31 17.3552C31 19.2713 32.5666 20.8256 34.5 20.8256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 34.7084C36.4324 34.7084 38 33.1541 38 31.238C38 29.3209 36.4324 27.7676 34.5 27.7676C32.5666 27.7676 31 29.3219 31 31.238C31 33.1541 32.5666 34.7084 34.5 34.7084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 48.5854C36.4324 48.5854 38 47.031 38 45.1149C38 43.1979 36.4324 41.6445 34.5 41.6445C32.5666 41.6445 31 43.1988 31 45.1149C31 47.032 32.5666 48.5854 34.5 48.5854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 62.4623C36.4324 62.4623 38 60.909 38 58.9919C38 57.0748 36.4324 55.5215 34.5 55.5215C32.5666 55.5215 31 57.0758 31 58.9919C31 60.908 32.5666 62.4623 34.5 62.4623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 75.3568C36.4324 75.3568 38 73.8035 38 71.8864C38 69.9693 36.4324 68.416 34.5 68.416C32.5666 68.416 31 69.9693 31 71.8864C31 73.8035 32.5666 75.3568 34.5 75.3568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 89.2416C36.4324 89.2416 38 87.6883 38 85.7712C38 83.8541 36.4324 82.3008 34.5 82.3008C32.5666 82.3008 31 83.8541 31 85.7712C31 87.6883 32.5666 89.2416 34.5 89.2416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 103.126C36.4324 103.126 38 101.572 38 99.656C38 97.7389 36.4324 96.1855 34.5 96.1855C32.5666 96.1855 31 97.7399 31 99.656C31 101.573 32.5666 103.126 34.5 103.126Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665_30853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 102.663,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisFrame);
export default __webpack_public_path__ + "static/media/mis_frame.92aa46825151fe0ea1b969e346e637da.svg";
export { ForwardRef as ReactComponent };